<script>
export default {
    name: 'parts-listing-ai',
    props: {
        value: { type: Object, default: () => ({}) },
    },
    methods: {
        patch(next) {
            this.$emit('input', {
                active: false,
                ...this.value,
                ...next,
            })
        },
    },

    computed: {
        isActive: {
            get() { return !!this.value.active },
            set(v) { this.patch({ active: !!v }) },
        },
        includePartNumbers: {
            get() { return !!this.value.number },
            set(v) { this.patch({ number: !!v }) },
        },
        includePartPricing: {
            get() { return !!this.value.pricing },
            set(v) { this.patch({ pricing: !!v }) },
        },
        autoAddImageForSupplier: {
            get() { return !!this.value.image },
            set(v) { this.patch({ image: !!v }) },
        },
    },

    created() {
        this.patch({})
    },
}
</script>


<template>
    <div style="margin-top: 15px; padding-left: 15px" class="card row no-gutter">
        <div class="col-lg-5 col-12">
            <div class="card-header bg-navyblue">
                <strong>Parts Listing AI</strong>
            </div>

            <div class="card-block bg-white">
                <div class="form-group row no-gutter">
                    <p>Manage Parts listings based on Make and Model</p>
                </div>

                <div class="form-group row no-gutter">
                    <label class="col-sm-5 col-form-label">Parts List - Intelligence</label>
                    <div class="col-sm-3">
                        <div class="d-flex align-items-center">
                            <toggle-button v-model="isActive" class="mb-0 rs-toggle__button" color="#5E79FF"
                                :sync="true" :width="40" :labels="false" />
                            <span class="form-text d-inline-block col-form-label mt-0 ml-0-25">
                                <template v-if="isActive">Active</template>
                                <template v-else>Not Active</template>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="form-group row no-gutter">
                  <label class="col-sm-5 col-form-label">Include Part Numbers</label>
                  <div class="col-sm-3">
                    <div class="d-flex align-items-center">
                      <label class="form-check-inline checkbox">
                        <input class="form-check-input" type="checkbox" v-model="includePartNumbers"
                               :disabled="!isActive" />
                        <span class="icon"><i v-if="includePartNumbers" class="bx bx-check"></i></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter">
                  <label class="col-sm-5 col-form-label">Include Part Pricing</label>
                  <div class="col-sm-3">
                    <div class="d-flex align-items-center">
                      <label class="form-check-inline checkbox">
                        <input class="form-check-input" type="checkbox" v-model="includePartPricing"
                               :disabled="true" />
                        <span class="icon"><i v-if="includePartPricing" class="bx bx-check"></i></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter">
                  <label class="col-sm-5 col-form-label">Auto Add Image - For Supplier</label>
                  <div class="col-sm-3">
                    <div class="d-flex align-items-center">
                      <label class="form-check-inline checkbox">
                        <input class="form-check-input" type="checkbox" v-model="autoAddImageForSupplier"
                               :disabled="!isActive" />
                        <span class="icon"><i v-if="autoAddImageForSupplier" class="bx bx-check"></i></span>
                      </label>
                    </div>
                  </div>
                </div>

                <hr />
            </div>
        </div>
    </div>
</template>

<style scoped>
.card-header.bg-navyblue {
    background: #e5e5e5;
    color: #333;
}

.form-text {
    color: #6b7280;
}

.form-check {
    padding: 4px 0;
}

.form-check-input {
    display: none;
}

.icon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    border: 2px solid #5e79ff;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #5e79ff;
}
</style>
